import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        validateLabel:'submit',
        delete: 'delete',
        labelUsersBattery: 'Users',
        labelUserBattery: 'User',
        labelTitle: 'Name',
        labelBattery: 'battery',
        labelSn: 'Serial Number',
        title: 'My battery',
        cellTitle: 'My cells',
        cellShortTitle: 'Cells',
        balancingState: 'balancing state',
        safetyDashboard: 'Safety dashboard',
        batteryTension: 'Battery Tension',
        cellList: 'Cells ({0})',
        cellName: 'Cell {0}',
        maxTension: 'Max Tension',
        minTension: 'Min Tension',
        differences: 'Difference',
        defaultsList: 'Defaults',
        onoff: 'On/Off',

        alarm: 'Alarm',
        charge: 'Charge',
        discharge: 'Discharge',
        overcharge: 'Overcharge',
        undercharge: 'Undercharge',
        temperature: 'Temperature',
        communication: 'Communication',

        lastUpdate: 'Last update at: {0}'
    },
    fr:{
        validateLabel:'Envoyer',
        delete: 'supprimer',
        labelUsersBattery: 'Utilisateurs',
        labelUserBattery: 'Utilisateurs',
        labelBattery: 'batterie',
        labelTitle: 'Nom',
        labelSn: 'Numéro de série',
        title: 'Ma batterie',
        cellTitle: 'Mes cellules',
        cellShortTitle: 'Cellules',
        safetyDashboard: 'Tableau de sécurité',
        batteryTension: 'Tension batterie',
        cellList: 'Cellules ({0})',
        cellName: 'Cellule {0}',
        balancingState:'État d\'équilibrage',
        maxTension: 'Tension max',
        minTension: 'Tension min',
        differences: 'Ecart',
        defaultsList: 'Défaut',
        onoff: 'On/Off',

        alarm: 'Alarme',
        charge: 'Charge',
        discharge: 'Décharge',
        overcharge: 'Surcharge',
        undercharge: 'Souscharge',
        temperature: 'Température',
        communication: 'Communication',

        lastUpdate: 'Dernière mise à jour: {0}'
    }
})

export default strings